import { Radio as MantineRadio, RadioProps as MantineRadioProps } from '@mantine/core';
import { JSX } from 'react';

import radioStyles from './Radio.module.css';
import { RadioIcon } from './RadioIcon';

export type RadioProps = Omit<MantineRadioProps, 'size'> & {
    'aria-label': string;
};

export const Radio: typeof MantineRadio & {
    (props: RadioProps): JSX.Element;
} = Object.assign(({ ...props }: RadioProps) => {
    return <MantineRadio className={radioStyles.root} icon={RadioIcon} {...props} />;
}, MantineRadio);
